import { render, staticRenderFns } from "./informesGeneradorConecta.vue?vue&type=template&id=79629b53&scoped=true&"
import script from "./informesGeneradorConecta.vue?vue&type=script&lang=ts&"
export * from "./informesGeneradorConecta.vue?vue&type=script&lang=ts&"
import style0 from "./informesGeneradorConecta.vue?vue&type=style&index=0&id=79629b53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79629b53",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('79629b53', component.options)
    } else {
      api.reload('79629b53', component.options)
    }
    module.hot.accept("./informesGeneradorConecta.vue?vue&type=template&id=79629b53&scoped=true&", function () {
      api.rerender('79629b53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReportesConecta/informesGeneradorConecta.vue"
export default component.exports